const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertifiedIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "301px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#11a387",
    d: "M 19.5,-0.5 C 98.5,-0.5 177.5,-0.5 256.5,-0.5C 265.842,2.67635 272.009,9.00969 275,18.5C 275.5,65.4988 275.667,112.499 275.5,159.5C 281.509,159.334 287.509,159.501 293.5,160C 296.35,161.021 298.35,162.854 299.5,165.5C 299.5,187.5 299.5,209.5 299.5,231.5C 297.576,242.026 293.41,251.693 287,260.5C 274.8,272.368 262.3,283.868 249.5,295C 246.909,297.117 244.242,298.95 241.5,300.5C 239.833,300.5 238.167,300.5 236.5,300.5C 220.565,287.742 204.732,274.742 189,261.5C 182.957,253.746 178.79,245.08 176.5,235.5C 175.384,211.853 175.218,188.186 176,164.5C 177.167,163.333 178.333,162.167 179.5,161C 210.746,159.515 242.079,159.015 273.5,159.5C 273.667,127.165 273.5,94.8316 273,62.5C 270.314,55.2712 265.48,50.1046 258.5,47C 178.21,45.3448 97.8771,45.0114 17.5,46C 10.1181,48.8863 4.45142,53.7196 0.5,60.5C 0.066219,45.4417 0.566219,30.4417 2,15.5C 5.50287,7.49214 11.3362,2.15881 19.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#10c9ac",
    d: "M 176.5,235.5 C 123.832,235.667 71.1656,235.5 18.5,235C 9.40807,232.072 3.07474,226.238 -0.5,217.5C -0.5,165.833 -0.5,114.167 -0.5,62.5C 0.338246,62.1583 0.67158,61.4916 0.5,60.5C 4.45142,53.7196 10.1181,48.8863 17.5,46C 97.8771,45.0114 178.21,45.3448 258.5,47C 265.48,50.1046 270.314,55.2712 273,62.5C 273.5,94.8316 273.667,127.165 273.5,159.5C 242.079,159.015 210.746,159.515 179.5,161C 178.333,162.167 177.167,163.333 176,164.5C 175.218,188.186 175.384,211.853 176.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 77.5,111.5 C 85.9839,112.493 94.6506,112.826 103.5,112.5C 103.5,118.833 103.5,125.167 103.5,131.5C 103.401,136.099 101.068,138.599 96.5,139C 86.5056,139.5 76.5056,139.666 66.5,139.5C 66.6664,131.16 66.4997,122.827 66,114.5C 64.8333,113.333 63.6667,112.167 62.5,111C 52.8391,110.5 43.1724,110.334 33.5,110.5C 33.3336,102.826 33.5003,95.1594 34,87.5C 34.4652,86.0692 35.2986,84.9025 36.5,84C 48.0651,82.5427 59.7318,82.0427 71.5,82.5C 71.3336,91.1731 71.5002,99.8397 72,108.5C 73.2635,110.607 75.0968,111.607 77.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 84.5,82.5 C 89.9586,82.1033 95.2919,82.6033 100.5,84C 101.333,84.8333 102.167,85.6667 103,86.5C 103.499,90.4862 103.666,94.4862 103.5,98.5C 97.1667,98.5 90.8333,98.5 84.5,98.5C 84.5,93.1667 84.5,87.8333 84.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1f1e9",
    d: "M 126.5,99.5 C 126.5,103.833 126.5,108.167 126.5,112.5C 130.833,112.5 135.167,112.5 139.5,112.5C 135.03,113.486 130.363,113.819 125.5,113.5C 125.181,108.637 125.514,103.97 126.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 126.5,99.5 C 130.833,99.5 135.167,99.5 139.5,99.5C 139.5,103.833 139.5,108.167 139.5,112.5C 139.5,108.167 139.5,103.833 139.5,99.5C 135.167,99.5 130.833,99.5 126.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 166.5,99.5 C 166.5,103.833 166.5,108.167 166.5,112.5C 162.167,112.5 157.833,112.5 153.5,112.5C 153.5,108.167 153.5,103.833 153.5,99.5C 157.833,99.5 162.167,99.5 166.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1f1e9",
    d: "M 166.5,99.5 C 167.486,103.97 167.819,108.637 167.5,113.5C 162.637,113.819 157.97,113.486 153.5,112.5C 157.833,112.5 162.167,112.5 166.5,112.5C 166.5,108.167 166.5,103.833 166.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1f1e9",
    d: "M 181.5,99.5 C 181.5,103.833 181.5,108.167 181.5,112.5C 185.833,112.5 190.167,112.5 194.5,112.5C 190.03,113.486 185.363,113.819 180.5,113.5C 180.181,108.637 180.514,103.97 181.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 181.5,99.5 C 185.833,99.5 190.167,99.5 194.5,99.5C 194.5,103.833 194.5,108.167 194.5,112.5C 194.5,108.167 194.5,103.833 194.5,99.5C 190.167,99.5 185.833,99.5 181.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 221.5,99.5 C 221.5,103.833 221.5,108.167 221.5,112.5C 217.167,112.5 212.833,112.5 208.5,112.5C 208.5,108.167 208.5,103.833 208.5,99.5C 212.833,99.5 217.167,99.5 221.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1f1e9",
    d: "M 221.5,99.5 C 222.486,103.97 222.819,108.637 222.5,113.5C 217.637,113.819 212.97,113.486 208.5,112.5C 212.833,112.5 217.167,112.5 221.5,112.5C 221.5,108.167 221.5,103.833 221.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1f1e9",
    d: "M 236.5,99.5 C 236.5,103.833 236.5,108.167 236.5,112.5C 240.833,112.5 245.167,112.5 249.5,112.5C 245.03,113.486 240.363,113.819 235.5,113.5C 235.181,108.637 235.514,103.97 236.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 236.5,99.5 C 240.833,99.5 245.167,99.5 249.5,99.5C 249.5,103.833 249.5,108.167 249.5,112.5C 249.5,108.167 249.5,103.833 249.5,99.5C 245.167,99.5 240.833,99.5 236.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0e9dd",
    d: "M 77.5,111.5 C 86.5,111.5 95.5,111.5 104.5,111.5C 104.824,118.354 104.491,125.021 103.5,131.5C 103.5,125.167 103.5,118.833 103.5,112.5C 94.6506,112.826 85.9839,112.493 77.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 33.5,124.5 C 40.1667,124.5 46.8333,124.5 53.5,124.5C 53.5,129.5 53.5,134.5 53.5,139.5C 47.7104,139.904 42.0438,139.404 36.5,138C 35.1068,136.829 34.2735,135.329 34,133.5C 33.502,130.518 33.3354,127.518 33.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafefd",
    d: "M 37.5,162.5 C 58.5026,162.333 79.5026,162.5 100.5,163C 104.629,165.631 105.462,169.131 103,173.5C 102.097,174.701 100.931,175.535 99.5,176C 79.1667,176.667 58.8333,176.667 38.5,176C 32.3036,171.873 31.9702,167.373 37.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafefd",
    d: "M 38.5,192.5 C 77.8347,192.333 117.168,192.5 156.5,193C 161.626,195.553 162.793,199.386 160,204.5C 159.25,205.126 158.416,205.626 157.5,206C 117.5,206.667 77.5,206.667 37.5,206C 32.0879,201.187 32.4212,196.687 38.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafdfc",
    d: "M 263.5,200.5 C 272.052,200.543 274.885,204.543 272,212.5C 261.104,224.065 249.604,234.899 237.5,245C 235.365,245.635 233.365,245.301 231.5,244C 222.636,235.47 214.136,226.637 206,217.5C 205.703,210.797 208.87,207.963 215.5,209C 222.636,215.135 229.469,221.635 236,228.5C 245.369,219.298 254.536,209.965 263.5,200.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifiedIndustry);
export default __webpack_public_path__ + "static/media/certifiedIndustry.95c381586411ccf221e3626f5dc240d2.svg";
export { ForwardRef as ReactComponent };